(function () {
  var SESSION_KEY = 'usssa:trial-popup-seen';

  var VARIANTS = {
    '-10': [
      { id: '45077603582208', label: '27" / 17 oz' },
      { id: '45077603614976', label: '28" / 18 oz' },
      { id: '45077603647744', label: '29" / 19 oz' },
      { id: '45077603680512', label: '30" / 20 oz' },
      { id: '45077603713280', label: '31" / 21 oz' }
    ],
    '-8': [
      { id: '46428889874688', label: '30" / 22 oz' },
      { id: '46428889907456', label: '31" / 23 oz' },
      { id: '46428889940224', label: '32" / 24 oz' }
    ],
    '-5': [
      { id: '46513967366400', label: '30" / 25 oz' },
      { id: '46513967399168', label: '31" / 26 oz' },
      { id: '46513967431936', label: '32" / 27 oz' }
    ]
  };

  var currentScreen = 1;
  var selectedDrop = null;
  var selectedVariantId = null;
  var popup = null;

  function initUsssaPopup() {
    var allowedPopupPaths = ['/', '/collections/usssa-bats'];
    var currentPath = window.location.pathname;
    var popupAllowed = allowedPopupPaths.some(function(path) {
      return currentPath === path || currentPath.startsWith(path + '/') || currentPath.startsWith(path + '?');
    });
    if (!popupAllowed) { return; }
    popup = document.querySelector('[data-usssa-popup]');
    if (!popup) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) {
          ticking = false;
          return;
        }
        var pct = window.scrollY / scrollable;
        if (pct >= 0.35) {
          showPopup();
          window.removeEventListener('scroll', onScroll);
        }
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function showPopup() {
    popup.removeAttribute('hidden');
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    var inner = popup.querySelector('.usssa-popup__inner');
    inner.addEventListener('click', onInnerClick);

    var closeBtn = popup.querySelector('[data-usssa-popup-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup, { once: true });
    }
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    sessionStorage.setItem(SESSION_KEY, '1');
    popup.addEventListener('transitionend', function () {
      popup.setAttribute('hidden', '');
    }, { once: true });
  }

  function goToScreen(n) {
    popup.querySelectorAll('.usssa-screen').forEach(function (s) {
      s.classList.remove('is-active');
    });
    var next = popup.querySelector('[data-screen="' + n + '"]');
    if (next) next.classList.add('is-active');
    currentScreen = n;
    var inner = popup.querySelector('.usssa-popup__inner');
    if (inner) inner.scrollTop = 0;
  }

  function renderSizeOptions(drop) {
    var grid = popup.querySelector('[data-size-grid]');
    if (!grid) return;
    var variants = VARIANTS[drop] || [];
    grid.innerHTML = variants.map(function (v) {
      var active = v.id === selectedVariantId ? ' is-active' : '';
      return (
        '<button class="usssa-size-btn' + active + '"' +
        ' data-action="select-size"' +
        ' data-variant-id="' + v.id + '">' +
        v.label +
        '</button>'
      );
    }).join('');
  }

  function selectDrop(drop) {
    selectedDrop = drop;
    selectedVariantId = null;

    popup.querySelectorAll('.usssa-drop-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.drop === drop);
    });

    var advanceBtn = popup.querySelector('[data-screen="2"] [data-action="advance"]');
    if (advanceBtn) advanceBtn.classList.add('usssa-cta--disabled');

    renderSizeOptions(drop);
  }

  function selectVariant(id) {
    selectedVariantId = id;

    popup.querySelectorAll('.usssa-size-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.variantId === id);
    });

    var advanceBtn = popup.querySelector('[data-screen="2"] [data-action="advance"]');
    if (advanceBtn) advanceBtn.classList.remove('usssa-cta--disabled');
  }

  function onInnerClick(e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;

    switch (el.dataset.action) {
      case 'advance':
        if (el.classList.contains('usssa-cta--disabled')) return;
        goToScreen(currentScreen + 1);
        break;
      case 'back':
        goToScreen(currentScreen - 1);
        break;
      case 'close':
        closePopup();
        break;
      case 'drop':
        selectDrop(el.dataset.drop);
        break;
      case 'select-size':
        selectVariant(el.dataset.variantId);
        break;
      case 'add-to-cart':
        if (!selectedVariantId) {
          console.log('No variant selected');
          return;
        }
        var ctaBtn = popup.querySelector('[data-action="add-to-cart"]');
        if (ctaBtn) {
          ctaBtn.disabled = true;
          ctaBtn.textContent = 'Adding…';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1, selling_plan: 4825153792 }] })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'error'); });
          window.location = '/checkout';
        })
        .catch(function(err) {
          if (ctaBtn) {
            ctaBtn.disabled = false;
            ctaBtn.textContent = 'Add to Cart — $0 Today';
          }
          console.error('Cart add failed:', err.message);
        });
        break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUsssaPopup);
  } else {
    initUsssaPopup();
  }
})();

/* ── USSSA Bat Fitting Quiz ─────────────────────────────────── */

(function () {
  var HEIGHT_KEYS = ['under-4', '4-0-4-4', '4-5-4-8', '4-9-5-0', '5-1-5-4', '5-5-5-8', '5-9-over'];
  var WEIGHT_KEYS = ['under-60', '61-70', '71-80', '81-90', '91-100', '101-110', '111-120', '121-130', '131-140', '141-150', '151-160', '161-170', '171-180', 'over-180'];

  /* 14 rows (weight) × 7 cols (height) — null = outside valid range */
  var LENGTH_MATRIX = [
    [26,   28,   29,   29,   null, null, null], // under-60
    [27,   28,   29,   30,   30,   null, null], // 61-70
    [null, 28,   29,   30,   30,   31,   null], // 71-80
    [null, 28,   29,   30,   30,   31,   32  ], // 81-90
    [null, 28,   29,   30,   30,   31,   32  ], // 91-100
    [null, 29,   29,   30,   30,   31,   32  ], // 101-110
    [null, 29,   29,   30,   30,   31,   32  ], // 111-120
    [null, 29,   30,   30,   30,   31,   32  ], // 121-130
    [null, 29,   30,   30,   31,   31,   32  ], // 131-140
    [null, null, 30,   30,   31,   31,   32  ], // 141-150
    [null, null, 30,   31,   31,   32,   32  ], // 151-160
    [null, null, null, 31,   31,   32,   32  ], // 161-170
    [null, null, null, null, null, 32,   33  ], // 171-180
    [null, null, null, null, null, 33,   33  ]  // over-180
  ];

  /* Required answer keys per step */
  var STEP_REQS = { 1: ['age'], 2: ['height', 'weight'], 3: ['swing'], 4: ['current_length', 'current_drop'] };
  var TOTAL_STEPS = 4;

  function lookupLength(weightKey, heightKey) {
    var ri = WEIGHT_KEYS.indexOf(weightKey);
    var ci = HEIGHT_KEYS.indexOf(heightKey);
    if (ri < 0 || ci < 0) return 29;
    if (LENGTH_MATRIX[ri][ci] !== null) return LENGTH_MATRIX[ri][ci];

    /* Fallback: step toward center (row 7, col 3) — row first, then column */
    var dr = (ri <= 7) ? 1 : -1;
    for (var r = ri + dr; r >= 0 && r < WEIGHT_KEYS.length; r += dr) {
      if (LENGTH_MATRIX[r][ci] !== null) return LENGTH_MATRIX[r][ci];
      if (r === 7) break;
    }
    var dc = (ci <= 3) ? 1 : -1;
    for (var c = ci + dc; c >= 0 && c < HEIGHT_KEYS.length; c += dc) {
      if (LENGTH_MATRIX[ri][c] !== null) return LENGTH_MATRIX[ri][c];
      if (c === 3) break;
    }
    return 29;
  }

  function computeDrop(age, swing) {
    if (age === 'under-10' || age === '10-11') return '-10';
    if (age === '13u') return '-8';
    if (age === '14u') return '-5';
    /* 12-13: base -10, one-step HR nudge to -8 */
    if (swing === 'Home Run Swing') return '-8';
    return '-10';
  }

  function initQuiz(container) {
    var answers     = {};
    var currentStep = 1;

    var progressBar = container.querySelector('[data-quiz-progress]');
    var navEl       = container.querySelector('[data-quiz-nav]');
    var backBtn     = container.querySelector('[data-quiz-back]');
    var nextBtn     = container.querySelector('[data-quiz-next]');

    function hasAnswer(step) {
      var reqs = STEP_REQS[step];
      return !!reqs && reqs.every(function (key) { return !!answers[key]; });
    }

    function showStep(n) {
      container.querySelectorAll('[data-quiz-step]').forEach(function (s) {
        s.classList.remove('is-active');
      });
      var el = container.querySelector('[data-quiz-step="' + n + '"]');
      if (el) el.classList.add('is-active');
      currentStep = n;

      var pct = (n === 'result' || n === 'redirect') ? 100 : ((n - 1) / TOTAL_STEPS * 100);
      if (progressBar) progressBar.style.width = pct + '%';

      if (n === 'result' || n === 'redirect') {
        navEl.hidden = true;
        if (n === 'result') renderResult();
      } else {
        navEl.hidden = false;
        backBtn.hidden = (n === 1);
        nextBtn.disabled = !hasAnswer(n);
      }
    }

    function renderResult() {
      var length = lookupLength(answers.weight, answers.height);
      var drop   = computeDrop(answers.age, answers.swing);
      container.querySelectorAll('[data-quiz-rec-length]').forEach(function (el) {
        el.textContent = length;
      });
      container.querySelectorAll('[data-quiz-rec-drop]').forEach(function (el) {
        el.textContent = drop;
      });
    }

    container.addEventListener('change', function (e) {
      var el = e.target.closest('[data-quiz-input]');
      if (!el || el.tagName !== 'SELECT') return;
      var key = el.dataset.quizInput;
      answers[key] = el.value || null;
      if (key === 'age' && answers[key] === '15plus') {
        showStep('redirect');
        return;
      }
      nextBtn.disabled = !hasAnswer(currentStep);
    });

    container.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-restart]')) {
        answers = {};
        showStep(1);
        container.querySelectorAll('[data-quiz-input]').forEach(function (el) {
          if (el.tagName === 'SELECT') el.value = '';
        });
        return;
      }

      var optBtn = e.target.closest('[data-quiz-input][data-quiz-value]');
      if (optBtn) {
        var key = optBtn.dataset.quizInput;
        answers[key] = optBtn.dataset.quizValue;
        optBtn.closest('.usssa-bat-quiz__options').querySelectorAll('.usssa-bat-quiz__opt-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        optBtn.classList.add('is-selected');
        nextBtn.disabled = false;
        return;
      }

      if (e.target.closest('[data-quiz-next]') && !nextBtn.disabled) {
        showStep(currentStep < TOTAL_STEPS ? currentStep + 1 : 'result');
        return;
      }

      if (e.target.closest('[data-quiz-back]') && currentStep > 1) {
        showStep(currentStep - 1);
        return;
      }
    });

    showStep(1);
  }

  function onReady() {
    document.querySelectorAll('[data-usssa-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

/* ── USSSA popup — 2-second delay on /collections/usssa-bats ── */

(function () {
  if (!window.location.pathname.startsWith('/collections/usssa-bats')) return;

  var SESSION_KEY = 'usssa:trial-popup-seen';

  var VARIANTS = {
    '-10': [
      { id: '45077603582208', label: '27" / 17 oz' },
      { id: '45077603614976', label: '28" / 18 oz' },
      { id: '45077603647744', label: '29" / 19 oz' },
      { id: '45077603680512', label: '30" / 20 oz' },
      { id: '45077603713280', label: '31" / 21 oz' }
    ],
    '-8': [
      { id: '46428889874688', label: '30" / 22 oz' },
      { id: '46428889907456', label: '31" / 23 oz' },
      { id: '46428889940224', label: '32" / 24 oz' }
    ],
    '-5': [
      { id: '46513967366400', label: '30" / 25 oz' },
      { id: '46513967399168', label: '31" / 26 oz' },
      { id: '46513967431936', label: '32" / 27 oz' }
    ]
  };

  var popup, currentScreen = 1, selectedDrop = null, selectedVariantId = null;

  function initCollectionDelay() {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    popup = document.querySelector('[data-usssa-popup]');
    if (!popup) return;
    setTimeout(maybeShow, 2000);
  }

  function maybeShow() {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    if (!popup || popup.classList.contains('is-visible')) return;
    popup.removeAttribute('hidden');
    requestAnimationFrame(function () { popup.classList.add('is-visible'); });
    popup.querySelector('.usssa-popup__inner').addEventListener('click', onInnerClick);
    var closeBtn = popup.querySelector('[data-usssa-popup-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePopup, { once: true });
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    sessionStorage.setItem(SESSION_KEY, '1');
    popup.addEventListener('transitionend', function () {
      popup.setAttribute('hidden', '');
    }, { once: true });
  }

  function goToScreen(n) {
    popup.querySelectorAll('.usssa-screen').forEach(function (s) { s.classList.remove('is-active'); });
    var next = popup.querySelector('[data-screen="' + n + '"]');
    if (next) next.classList.add('is-active');
    currentScreen = n;
    var inner = popup.querySelector('.usssa-popup__inner');
    if (inner) inner.scrollTop = 0;
  }

  function renderSizes(drop) {
    var grid = popup.querySelector('[data-size-grid]');
    if (!grid) return;
    grid.innerHTML = (VARIANTS[drop] || []).map(function (v) {
      return '<button class="usssa-size-btn' + (v.id === selectedVariantId ? ' is-active' : '') +
        '" data-action="select-size" data-variant-id="' + v.id + '">' + v.label + '</button>';
    }).join('');
  }

  function selectDrop(drop) {
    selectedDrop = drop;
    selectedVariantId = null;
    popup.querySelectorAll('.usssa-drop-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.drop === drop);
    });
    var adv = popup.querySelector('[data-screen="2"] [data-action="advance"]');
    if (adv) adv.classList.add('usssa-cta--disabled');
    renderSizes(drop);
  }

  function selectVariant(id) {
    selectedVariantId = id;
    popup.querySelectorAll('.usssa-size-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.variantId === id);
    });
    var adv = popup.querySelector('[data-screen="2"] [data-action="advance"]');
    if (adv) adv.classList.remove('usssa-cta--disabled');
  }

  function onInnerClick(e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;
    switch (el.dataset.action) {
      case 'advance':
        if (!el.classList.contains('usssa-cta--disabled')) goToScreen(currentScreen + 1);
        break;
      case 'back':         goToScreen(currentScreen - 1); break;
      case 'close':        closePopup(); break;
      case 'drop':         selectDrop(el.dataset.drop); break;
      case 'select-size':  selectVariant(el.dataset.variantId); break;
      case 'add-to-cart':
        if (!selectedVariantId) {
          console.log('No variant selected');
          return;
        }
        var ctaBtn = popup.querySelector('[data-action="add-to-cart"]');
        if (ctaBtn) {
          ctaBtn.disabled = true;
          ctaBtn.textContent = 'Adding…';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1, selling_plan: 4825153792 }] })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'error'); });
          window.location = '/checkout';
        })
        .catch(function(err) {
          if (ctaBtn) {
            ctaBtn.disabled = false;
            ctaBtn.textContent = 'Add to Cart — $0 Today';
          }
          console.error('Cart add failed:', err.message);
        });
        break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDelay);
  } else {
    initCollectionDelay();
  }
})();

/* ── USSSA Trial PDP ────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function initTrialPDP() {
    var pdp = document.getElementById('trial-pdp');
    if (!pdp) return;

    var sizesWrap  = document.getElementById('trial-pdp-sizes');
    var ctaBtn     = document.getElementById('trial-pdp-cta');
    var accordion  = document.getElementById('trial-pdp-accordion');
    var thumbsWrap = document.getElementById('trial-pdp-thumbs');

    // Drop weight buttons
    pdp.querySelectorAll('.trial-pdp__drop-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.handle;
        if (handle === window.TrialPDP.productHandle) return;
        onDropClick(btn, handle);
      });
    });

    // Size buttons — delegated so rebuilt buttons work
    sizesWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.trial-pdp__size-btn');
      if (!btn || btn.disabled) return;
      onSizeClick(btn);
    });

    // CTA
    ctaBtn.addEventListener('click', onCTAClick);

    // Thumbnails — delegated so rebuilt thumbs work
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var thumb = e.target.closest('.trial-pdp__thumb');
        if (!thumb) return;
        onThumbClick(thumb);
      });
    }

    // Accordion
    if (accordion) {
      var toggle = accordion.querySelector('.trial-pdp__accordion-toggle');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = accordion.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    }
  }

  function onDropClick(btn, handle) {
    // Mark active drop button
    document.querySelectorAll('.trial-pdp__drop-btn').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    // Reset state
    window.TrialPDP.variantId = null;
    clearMsg('size');
    clearMsg('cta');

    // Loading state on size area
    var sizesWrap = document.getElementById('trial-pdp-sizes');
    sizesWrap.classList.add('is-loading');
    sizesWrap.innerHTML = '<span style="font-size:12px;opacity:0.45;padding:8px 0;display:block">Loading sizes…</span>';

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('network');
        return res.json();
      })
      .then(function (data) {
        window.TrialPDP.productHandle = data.handle;
        var titleEl = document.querySelector('.trial-pdp__title');
        if (titleEl && data.title) {
          titleEl.textContent = data.title;
        }
        buildSizeButtons(data.variants);
        sizesWrap.classList.remove('is-loading');
        if (data.images && data.images.length) updateGallery(data.images);
      })
      .catch(function () {
        sizesWrap.classList.remove('is-loading');
        sizesWrap.innerHTML = '<span style="font-size:12px;color:#e32c2b;">Could not load sizes — try refreshing.</span>';
      });
  }

  function buildSizeButtons(variants) {
    var sizesWrap = document.getElementById('trial-pdp-sizes');
    sizesWrap.innerHTML = '';
    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.className = 'trial-pdp__size-btn';
      btn.dataset.variantId = v.id;
      btn.textContent = v.title.split(' Drop')[0];
      if (!v.available) btn.disabled = true;
      sizesWrap.appendChild(btn);
    });
  }

  function onSizeClick(btn) {
    document.querySelectorAll('.trial-pdp__size-btn').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');
    window.TrialPDP.variantId = Number(btn.dataset.variantId);
    clearMsg('size');
  }

  function onCTAClick() {
    if (!window.TrialPDP.variantId) {
      showMsg('size', 'Please select a size first.');
      return;
    }
    clearMsg('cta');
    var cta = document.getElementById('trial-pdp-cta');
    cta.disabled = true;
    cta.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: window.TrialPDP.variantId, quantity: 1, selling_plan: 4825153792 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'error'); });
        window.location = '/checkout';
      })
      .catch(function (err) {
        cta.disabled = false;
        cta.textContent = 'Start My 60-Day Trial';
        showMsg('cta', err.message || 'Something went wrong — please try again.');
      });
  }

  function onThumbClick(thumb) {
    document.querySelectorAll('.trial-pdp__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    var mainImg = document.getElementById('trial-pdp-main-img');
    if (mainImg && thumb.dataset.src) {
      mainImg.src = thumb.dataset.src;
      mainImg.alt = thumb.dataset.alt || '';
    }
  }

  function updateGallery(images) {
    var mainImg    = document.getElementById('trial-pdp-main-img');
    var thumbsWrap = document.getElementById('trial-pdp-thumbs');

    // images from /products/handle.js are URL strings
    var firstSrc = typeof images[0] === 'string' ? images[0] : (images[0].src || '');
    if (mainImg && firstSrc) {
      mainImg.src = firstSrc;
      mainImg.alt = '';
      mainImg.style.width = '100%';
      mainImg.style.height = '100%';
    }

    if (!thumbsWrap) return;

    if (images.length <= 1) {
      thumbsWrap.style.display = 'none';
      return;
    }

    thumbsWrap.style.display = '';
    thumbsWrap.innerHTML = '';
    images.forEach(function (img, i) {
      var src = typeof img === 'string' ? img : (img.src || '');
      if (!src) return;
      var btn = document.createElement('button');
      btn.className = 'trial-pdp__thumb' + (i === 0 ? ' is-active' : '');
      btn.dataset.src = src;
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'lazy';
      im.width = 120;
      im.height = 120;
      btn.appendChild(im);
      thumbsWrap.appendChild(btn);
    });
  }

  function showMsg(target, msg) {
    var id = target === 'size' ? 'trial-pdp-size-error' : 'trial-pdp-cta-error';
    var el = document.getElementById(id);
    if (el) el.textContent = msg;
  }

  function clearMsg(target) {
    var id = target === 'size' ? 'trial-pdp-size-error' : 'trial-pdp-cta-error';
    var el = document.getElementById(id);
    if (el) el.textContent = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrialPDP);
  } else {
    initTrialPDP();
  }
})();

/* ── Bonesaber Cards — expand / collapse ────────────────────── */

(function () {
  var resizeTimer = null;

  function checkOverflow() {
    document.querySelectorAll('.usssa-cards__card').forEach(function (card) {
      var body   = card.querySelector('.usssa-cards__card-body');
      var toggle = card.querySelector('.usssa-cards__card-toggle');
      if (!body || !toggle) return;
      if (!body.classList.contains('is-expanded')) {
        toggle.style.display = body.scrollHeight > body.clientHeight ? '' : 'none';
      }
    });
  }

  function initCards() {
    document.querySelectorAll('.usssa-cards__grid').forEach(function (grid) {
      grid.addEventListener('click', function (e) {
        var toggle = e.target.closest('.usssa-cards__card-toggle');
        if (!toggle) return;
        var card = toggle.closest('.usssa-cards__card');
        if (!card) return;
        var body = card.querySelector('.usssa-cards__card-body');
        if (!body) return;
        var expanded = body.classList.toggle('is-expanded');
        body.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Read less' : 'Read more';
        if (!expanded) {
          toggle.style.display = body.scrollHeight > body.clientHeight ? '' : 'none';
        }
      });
    });

    checkOverflow();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkOverflow, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
})();

/* ── USSSA Trial Flow ───────────────────────────────────────── */

(function () {
  'use strict';

  var STEP_MS    = 2000;
  var CONN_MS    = 600;
  var PAUSE_MS   = 2000;
  var RESUME_MS  = 4000;

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function buildSeq() {
    var seq = [
      { type: 'activate', key: '1',            wait: STEP_MS },
      { type: 'draw',     key: 'c-1',          wait: CONN_MS },
      { type: 'activate', key: '2',            wait: STEP_MS },
      { type: 'draw',     key: 'c-2',          wait: CONN_MS },
      { type: 'activate', key: '3',            wait: STEP_MS },
      { type: 'draw',     key: 'c-3',          wait: CONN_MS },
      { type: 'activate', key: '4',            wait: STEP_MS },
      { type: 'draw',     key: 'branch-stem',  wait: CONN_MS }
    ];

    if (isDesktop()) {
      seq.push({ type: 'drawMulti', keys: ['branch-bar-left', 'branch-bar-right'], wait: CONN_MS });
    }

    seq.push({ type: 'activateMulti', keys: ['branch-a', 'branch-b'], wait: STEP_MS });

    return seq;
  }

  function initFlow(track) {
    var steps      = {};
    var connectors = {};
    var timer      = null;
    var running    = false;
    var userTimer  = null;

    track.querySelectorAll('[data-flow-step]').forEach(function (el) {
      steps[el.dataset.flowStep] = el;
    });
    track.querySelectorAll('[data-flow-connector]').forEach(function (el) {
      connectors[el.dataset.flowConnector] = el;
    });

    function activateStep(key) {
      if (steps[key]) steps[key].classList.add('is-active');
    }

    function drawConn(key) {
      var el = connectors[key];
      if (el) {
        el.classList.add('is-drawing');
        el.classList.add('is-drawn');
      }
    }

    function resetAll() {
      Object.keys(steps).forEach(function (k) {
        steps[k].classList.remove('is-active');
      });
      Object.keys(connectors).forEach(function (k) {
        connectors[k].classList.remove('is-drawing', 'is-drawn');
      });
    }

    function run(seq, i) {
      if (!running || i >= seq.length) {
        running = false;
        return;
      }

      var step = seq[i];

      function next() {
        timer = setTimeout(function () { run(seq, i + 1); }, step.wait);
      }

      switch (step.type) {
        case 'activate':
          activateStep(step.key);
          next();
          break;
        case 'activateMulti':
          step.keys.forEach(activateStep);
          next();
          break;
        case 'draw':
          drawConn(step.key);
          next();
          break;
        case 'drawMulti':
          step.keys.forEach(drawConn);
          next();
          break;
        case 'pause':
          next();
          break;
        case 'reset':
          resetAll();
          next();
          break;
      }
    }

    function start() {
      if (running) return;
      running = true;
      resetAll();
      run(buildSeq(), 0);
    }

    function stop() {
      running = false;
      clearTimeout(timer);
      resetAll();
    }

    /* Click: jump to step and pause auto-play */
    track.addEventListener('click', function (e) {
      var stepEl = e.target.closest('[data-flow-step]');
      if (!stepEl) return;
      stop();
      stepEl.classList.add('is-active');
      clearTimeout(userTimer);
      userTimer = setTimeout(start, RESUME_MS);
    });

    /* IntersectionObserver: start once — disconnect after firing so it never replays */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            observer.disconnect();
          }
        });
      }, { threshold: 0.25 });

      var section = track.closest('.usssa-flow') || track;
      observer.observe(section);
    } else {
      start();
    }
  }

  function onReady() {
    document.querySelectorAll('[data-flow-track]').forEach(initFlow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

/* ── Klaviyo Question Modal ──────────────────────────────────── */
(function () {
  var COMPANY_ID = 'Yy3G8F';
  var LIST_ID = 'RjPhsA';

  function getOverlay() {
    return document.querySelector('[data-kmodal-overlay]');
  }

  function openModal() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetModal(overlay) {
    var form = overlay.querySelector('[data-kmodal-form]');
    var success = overlay.querySelector('[data-kmodal-success]');
    var err = overlay.querySelector('[data-kmodal-error]');
    var submit = overlay.querySelector('.usssa-kmodal__submit');
    if (form) { form.removeAttribute('hidden'); form.reset(); }
    if (success) success.setAttribute('hidden', '');
    if (err) err.setAttribute('hidden', '');
    if (submit) { submit.disabled = false; }
  }

  function showSuccess(overlay) {
    var form = overlay.querySelector('[data-kmodal-form]');
    var success = overlay.querySelector('[data-kmodal-success]');
    if (form) form.setAttribute('hidden', '');
    if (success) success.removeAttribute('hidden');
    setTimeout(function () {
      closeModal();
      setTimeout(function () { resetModal(overlay); }, 400);
    }, 4000);
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var overlay = form.closest('[data-kmodal-overlay]');
    var submit = form.querySelector('.usssa-kmodal__submit');
    var err = form.querySelector('[data-kmodal-error]');

    if (err) err.setAttribute('hidden', '');

    var name = (form.querySelector('[name="name"]').value || '').trim();
    var email = (form.querySelector('[name="email"]').value || '').trim();
    var question = (form.querySelector('[name="question"]').value || '').trim();

    if (!name || !email || !question) return;

    var originalText = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Sending…';

    var source = window.location.pathname.indexOf('composite-break-in-guide') !== -1
      ? 'Break-in guide modal'
      : 'FAQ page modal';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: name,
                properties: {
                  usssa_trial_question: question,
                  question_source: source
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: LIST_ID
            }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (res.ok || res.status === 202) {
        showSuccess(overlay);
      } else {
        throw new Error('status ' + res.status);
      }
    }).catch(function () {
      submit.disabled = false;
      submit.textContent = originalText;
      if (err) err.removeAttribute('hidden');
    });
  }

  function onDocClick(e) {
    if (e.target.closest('[data-klaviyo-modal="open"]')) {
      e.preventDefault();
      openModal();
      return;
    }
    var link = e.target.closest('a[href="#klaviyo-modal"]');
    if (link) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.matches('[data-kmodal-overlay]')) {
      closeModal();
      return;
    }
    if (e.target.closest('[data-kmodal-close]')) {
      closeModal();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      var overlay = getOverlay();
      if (overlay && overlay.classList.contains('is-open')) closeModal();
    }
  }

  function onReady() {
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeydown);
    var form = document.querySelector('[data-kmodal-form]');
    if (form) form.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

(function () {
  'use strict';

  var APP_KEY   = 'v0y28WKzeX7aOtnmF2gUsJeA9RcaC80xvx8cFo8w';
  var AUTO_MS   = 4000;
  var RESUME_MS   = 6000;
  var FADE_MS     = 300;
  var MAX_DOTS    = 10;
  var MIN_SWIPE   = 50;

  function fetchReviews(productId) {
    var url =
      'https://api.yotpo.com/v1/widget/' +
      APP_KEY +
      '/products/' +
      productId +
      '/reviews.json?per_page=20&star=5';
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        return data && data.response && Array.isArray(data.response.reviews)
          ? data.response.reviews
          : [];
      })
      .catch(function () { return []; });
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j   = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i]  = arr[j];
      arr[j]  = tmp;
    }
    return arr;
  }

  function truncate(str, max) {
    str = (str || '').trim();
    return str.length > max ? str.slice(0, max).trimEnd() + '…' : str;
  }

  function formatName(review) {
    var name = (review.user && review.user.display_name)
      ? review.user.display_name.trim()
      : '';
    if (!name) return '';
    var parts = name.split(/\s+/);
    if (parts.length >= 2) {
      return parts[0] + ' ' + parts[parts.length - 1][0].toUpperCase() + '.';
    }
    return parts[0];
  }

  function init() {
    var section = document.querySelector('[data-usssa-yotpo-reviews]');
    if (!section) return;

    var rawIds = section.getAttribute('data-product-ids') || '';
    var productIds = rawIds
      ? rawIds.split(',').map(function (id) { return id.trim(); }).filter(Boolean)
      : ['8634616545536', '9025986855168', '9051113849088'];

    var reviewCount = parseInt(section.getAttribute('data-review-count'), 10) || 10;
    var card        = section.querySelector('.usssa-yotpo-reviews__card');
    var bodyEl      = section.querySelector('.usssa-yotpo-reviews__body');
    var authorEl    = section.querySelector('.usssa-yotpo-reviews__author');
    var verifiedEl  = section.querySelector('.usssa-yotpo-reviews__verified');
    var dotsWrap    = section.querySelector('.usssa-yotpo-reviews__dots');
    var prevBtn     = section.querySelector('.usssa-yotpo-reviews__arrow--prev');
    var nextBtn     = section.querySelector('.usssa-yotpo-reviews__arrow--next');

    var pool = [], current = 0, dotEls = [];
    var autoTimer = null, resumeTimer = null, busy = false;

    Promise.all(productIds.map(fetchReviews)).then(function (results) {
      var merged = [].concat.apply([], results);
      var fived  = merged.filter(function (r) { return r.score === 5; });
      shuffle(fived);
      pool = fived.slice(0, reviewCount);
      if (!pool.length) return;

      section.style.display = '';
      buildDots();
      renderAt(0);

      prevBtn.addEventListener('click', function () { step(-1); pauseAndResume(); });
      nextBtn.addEventListener('click', function () { step(1);  pauseAndResume(); });

      var txStart = 0;
      section.addEventListener('touchstart', function (e) {
        txStart = e.touches[0].clientX;
      }, { passive: true });
      section.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - txStart;
        if (Math.abs(dx) < MIN_SWIPE) return;
        step(dx < 0 ? 1 : -1);
        pauseAndResume();
      }, { passive: true });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { startAuto(); } else { stopAuto(); }
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    });

    function buildDots() {
      var count = Math.min(pool.length, MAX_DOTS);
      dotsWrap.innerHTML = '';
      dotEls = [];
      for (var i = 0; i < count; i++) {
        var span = document.createElement('span');
        span.className = 'usssa-yotpo-reviews__dot';
        dotsWrap.appendChild(span);
        dotEls.push(span);
      }
    }

    function updateDots(idx) {
      var active = idx % dotEls.length;
      dotEls.forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }

    function renderAt(idx) {
      var r = pool[idx];
      bodyEl.textContent   = truncate(r.content, 280);
      authorEl.textContent = formatName(r);
      verifiedEl.style.display = r.verified_buyer ? '' : 'none';
      if (dotEls.length) updateDots(idx);
    }

    function goTo(idx) {
      if (busy || idx === current) return;
      busy = true;
      card.classList.add('is-fading');
      setTimeout(function () {
        current = idx;
        renderAt(current);
        card.classList.remove('is-fading');
        setTimeout(function () { busy = false; }, FADE_MS);
      }, FADE_MS);
    }

    function step(dir) {
      goTo((current + dir + pool.length) % pool.length);
    }

    function startAuto() {
      if (autoTimer) return;
      autoTimer = setInterval(function () { step(1); }, AUTO_MS);
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    function pauseAndResume() {
      stopAuto();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAuto, RESUME_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ----------------------------------------------------------------------------------------------------------------------
   APPAREL PRODUCT CARD — QUICK-ADD AJAX
   ---------------------------------------------------------------------------------------------------------------------- */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ERROR_DURATION_MS = 1500;

  function init() {
    document.addEventListener('click', onClick);
  }

  function onClick(event) {
    var pill = event.target.closest('[data-apparel-add-to-cart]');
    if (!pill || pill.classList.contains('is-loading')) return;

    event.preventDefault();
    addToCart(pill);
  }

  function addToCart(pill) {
    pill.classList.remove('has-error');
    pill.classList.add('is-loading');

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var formData = new FormData();
    formData.set('id', pill.getAttribute('data-variant-id'));
    formData.set('quantity', '1');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', root);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(pill);
          return;
        }

        return fetch(root + 'cart.js')
          .then(function (cartResponse) { return cartResponse.json(); })
          .then(function (cart) {
            cart.sections = result.json.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                cart: cart,
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer'
              }
            }));
          });
      })
      .catch(function () {
        showError(pill);
      })
      .finally(function () {
        pill.classList.remove('is-loading');
      });
  }

  function showError(pill) {
    pill.classList.add('has-error');
    setTimeout(function () {
      pill.classList.remove('has-error');
    }, ERROR_DURATION_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// TryOn trial-button persistence fix
// TryOn's app-embed button is injected client-side into <buy-buttons> after page
// load. Prestige's ProductRerender.onRerender_fn (theme.js) wholesale-replaces the
// <buy-buttons> element on every variant switch (allow-partial-rerender block-swap,
// see sections/main-product.liquid), destroying TryOn's injected button with it.
// TryOn support confirmed their script has no listener for this and recommended
// capturing + reinjecting the button ourselves. `variant:change` fires
// synchronously AFTER the product:rerender swap completes (confirmed in theme.js
// VariantPicker.selectCombination), so no timing race/delay is needed here.
(function () {
  'use strict';

  var capturedExtrasByForm = new WeakMap();

  function isNativeBuyButtonsChild(el) {
    return el.matches('button, .shopify-payment-button, script, style');
  }

  function captureExtras(buyButtons) {
    return Array.from(buyButtons.children).filter(function (el) {
      return !isNativeBuyButtonsChild(el);
    });
  }

  function watchInitialInjection(form) {
    var buyButtons = form.querySelector('buy-buttons');
    if (!buyButtons) return;

    var existing = captureExtras(buyButtons);
    if (existing.length) {
      capturedExtrasByForm.set(form, existing);
      return;
    }

    var observer = new MutationObserver(function () {
      var extras = captureExtras(buyButtons);
      if (extras.length) {
        capturedExtrasByForm.set(form, extras);
        observer.disconnect();
      }
    });
    observer.observe(buyButtons, { childList: true });

    // TryOn only injects on eligible products/variants (USSSA composite bats) —
    // stop watching if nothing shows up so we don't leave an observer running.
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  function onVariantChange(event) {
    var form = event.target;
    if (!form || !(form instanceof HTMLFormElement)) return;

    var extras = capturedExtrasByForm.get(form);
    if (!extras || !extras.length) return;

    var newBuyButtons = form.querySelector('buy-buttons');
    if (!newBuyButtons) return;

    // If TryOn has already re-injected itself independently by the time this
    // runs, don't duplicate it — just refresh our captured reference instead.
    var currentExtras = captureExtras(newBuyButtons);
    if (currentExtras.length) {
      capturedExtrasByForm.set(form, currentExtras);
      return;
    }

    extras.forEach(function (el) {
      newBuyButtons.appendChild(el);
    });

    // Track the new <buy-buttons> instance in case of another variant switch.
    watchInitialInjection(form);
  }

  function init() {
    // Scoped to sections/main-product.liquid's primary PDP form (id prefix
    // "product-form-main-") — not quick-buy modals or product cards, which
    // aren't where the trial-button persistence bug was reported.
    document.querySelectorAll('product-form form[id^="product-form-main-"]').forEach(watchInitialInjection);
    document.addEventListener('variant:change', onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
